import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['top', 'border'];

  connect() {
    this.handleScroll = this.reveal.bind(this);
    window.addEventListener('scroll', this.handleScroll);
    this.reveal();
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  reveal() {
    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate progress: 0 when section enters, 1 when about to leave
    let progress = (windowHeight - rect.top) / (windowHeight + rect.height);
    progress = Math.min(Math.max(progress, 0), 1);

    this.topTarget.style.clipPath = `inset(0 ${progress * 100}% 0 0)`;

    const containerWidth = this.topTarget.offsetWidth;
    const borderX = progress * containerWidth;
    this.borderTarget.style.left = `${containerWidth - borderX - 2}px`;
  }
}
